import React from 'react';
import styled from 'styled-components';

import Debt from './DebtRow';

const DebtGrid = styled.div`
  display: grid;
  height: 100%;
  padding: 10px;
  grid-template-columns: 1fr;
`;

const distinctColors = ({ count = 1, lightness }) => {
  const increment = Math.floor(360 / count);
  return [...Array(count)].map((_, i) => {
    return `hsl(${increment * i}, ${lightness}%, ${lightness}%)`;
  });
};

const DebtGridRows = ({ debts, settings, onBalanceAction }) => {
  const COLORS = distinctColors({
    count: debts.length,
    lightness: 30,
  });

  return (
    <DebtGrid length={debts.length}>
      {debts.map((debt, i) => (
        <Debt
          key={debt.id}
          color={COLORS[i]}
          allowActions={settings.allowActions}
          incrementType={settings.incrementType}
          steps={settings.specificity}
          onBalanceAction={onBalanceAction}
          {...debt}
        />
      ))}
    </DebtGrid>
  );
};

export default DebtGridRows;



// WEBPACK FOOTER //
// ./src/components/DebtRainbow/DebtGridRows.js